import { RouteInfo } from './sidebar.metadata';

export const ROUTES: RouteInfo[] = [
  {
    path: '',
    title: 'Acciones',
    icon: 'mdi mdi-folder-multiple',
    class: 'has-arrow',
    label: '',
    labelClass: '',
    extralink: false,
    submenu: [
      {
        path: '/consultas/estado-de-cuenta',
        title: 'Estado de cuenta',
        icon: 'mdi mdi-account-box-outline',
        class: '',
        label: '',
        labelClass: '',
        extralink: false,
        submenu: []
      },
      {
        path: '/consultas/ayuda',
        title: 'Ayuda',
        icon: 'mdi mdi-help',
        class: '',
        label: '',
        labelClass: '',
        extralink: false,
        submenu: []
      }
    ]
  }
];
